/* eslint-disable */
import React from "react";
import Card from "@material-ui/core/Card";
import Accordion from "../components/Accordion";
import useCollapse from 'react-collapsed';
import { faqQuestions, faqOverview } from "../components/FaqContent.jsx";
import "../css/FaqPage.css";

/**
 * This function renders an FAQ element
 * @component FAQElement
 * @return {Component} FAQElement component
 */
 function FAQElement(props) {
  const { getCollapseProps, getToggleProps, isExpanded } = useCollapse();

  return (
    <div className="faq-card-collapsible">
    <div className="faq-card-header" {...getToggleProps()}>
      <div className="faq-card">
        <p>{props.question}</p>
        <p>{isExpanded ? '-' : '+'}</p>
      </div>
    </div>
    <div {...getCollapseProps()}>
        <div className="faq-card-content">
          <p>{props.answer}</p>
        </div>
    </div>
</div>
  );
}

/**
 * This function renders the FAQ page
 * @component FAQPage
 * @return {Component} FAQPage component
 */
export default function FAQPage() {

  return (
    <div>
      <Card className="faq-container">
        <div style={{ padding: "20px" }}>
          <h1
            style={{
              textAlign: "center",
              fontSize: "36px",
              padding: "20px",
              borderBottom: "1px solid silver",
            }}
          >
            Introducing AIS
            <div style={{height: '30px'}} />
          </h1>
          <div className="faq-overview">
            {faqOverview.map((data, index) => {
              return (
                <div className="faq-overview-item">
                  <Accordion
                    key={index}
                    title={data.title}
                    content={data.content}
                    buttonColor="#4E99AD"
                    headingTextSize="24px"
                    textSize="22px"
                    iconSize={40}
                  />
                </div>
              );
            })}
          </div>
          <div style={{ height: "50px" }} />
          <h1 style={{ marginLeft: "10px" }}>Frequently Asked Questions</h1>
          <div style={{height: '15px'}} />
          <div className="faq-content">
            {faqQuestions.map((data, index) => {
              return(
                <div key={index}>
                  <FAQElement question={data.question} answer={data.answer}/>
                </div>
              )
            })}
          </div>
        </div>
        <br />
      </Card>
      <br />
      <br />
      <br />
      <br />
      <br />
    </div>
  );
}
